import React from 'react';
import logo from'../assets/logo.png';
function Banner() {

    return (
        <div className="w-full container mx-auto hidden lg:block">

            <div className="bg-gradient-to-br from-amber-500 to-yellow-300 rounded-[25px] justify-center items-center mt-10 mx-10">

                <div className="flex flex-row px-10 pt-16">

                    <div className="w-1/2 flex flex-col justify-center">
                       <h1 className="text-white font-semibold text-6xl">
                           Happy Taxi
                       </h1>

                        <p className="mt-8 text-2xl font-light text-white">Aplicación móvil que te ayuda a reservar tu viaje en taxi de forma rápida y eficiente</p>

                        <div className="flex flex-row gap-x-5 pt-20">

                            <a href="#" className="bg-white rounded-full px-10 py-4 text-sm flex gap-x-2 hover:scale-95">
                                <span className="text-lg font-semibold text-gray-600">App Store</span>
                            </a>

                            <a href="#" className="bg-white rounded-full px-10 py-4 text-sm flex gap-x-2 hover:scale-95">
                                <span className="text-lg font-semibold text-gray-600">Play Store</span>
                            </a>
                        </div>

                    </div>

                    <div className="w-1/2">
                       <div className="overflow-hidden relative flex justify-center items-center">
                           <img src="https://tappsk.com/img/mockup.png" className="w-[400px] -top-0 absolute " alt=""/>
                          <div className="w-[400px] h-[500px] bg-white rounded-t-[50px] flex justify-center items-center">
                              <img src={logo} className="w-32 mt-10" alt=""/>
                          </div>
                       </div>
                    </div>

                </div>

            </div>

        </div>
    );
}

export default Banner;